<!--盘点单镜片-->
<template>
  <el-dialog custom-class="medium-dialog" title="盘点单" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"
             :append-to-body="true">
    <MakeInventoryEdit ref="MakeInventoryEdit1" @close="dialogFormVisible=false;" v-if="showLens" @bindGrid="bindGrid" :jxcstoreDataf="jxcstoreDataf" :loading="loading" :btnvisible="btnvisible"></MakeInventoryEdit>
    <MakeInventoryFrameEdit ref="MakeInventoryFrameEdit1" @close="dialogFormVisible=false;" v-if="showFrame" @bindGrid="bindGrid" :jxcstoreDataf="jxcstoreDataf"  :loading="loading" :btnvisible="btnvisible"></MakeInventoryFrameEdit>
    <MakeInventoryOtherEdit ref="MakeInventoryOtherEdit1" @close="dialogFormVisible=false;" v-if="showOther" @bindGrid="bindGrid" :jxcstoreDataf="jxcstoreDataf"  :loading="loading" :btnvisible="btnvisible"></MakeInventoryOtherEdit>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible=false;">取 消</el-button>
      <el-button type="warning" @click="toFormat(false)" plain v-if="btnvisible">默认库存</el-button>
      <el-button type="warning" @click="toZero(false)" plain v-if="btnvisible">清零</el-button>
      <el-button type="warning" @click="toZero(true)" plain v-if="btnvisible">还原</el-button>
      <el-button type="primary" @click="saveData" v-if="btnvisible" :loading="loading">保 存</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {cusandptbyind} from '@/api/set/jxcstore';
  import MakeInventoryEdit from './MakeInventoryEdit';
  import MakeInventoryFrameEdit from './MakeInventoryFrameEdit';
  import MakeInventoryOtherEdit from './MakeInventoryOtherEdit';
  import {looklist} from '@/api/set/jxcstoreformdetail';

  export default {
    name: 'MakeInventorySwitch',
    msg: '盘点单',
    data() {
      return {
        jxcstoreDataf:[],
        component:null,
        loading:false,
        btnvisible:false,
        showLens:false,
        showFrame:false,
        showOther:false,
        dialogFormVisible: false,
      }
    },
    methods: {
      bindGrid(){
        this.$emit('bindGrid');
      },
      initForm(){
        this.showLens = false;
        this.showFrame = false;
        this.showOther = false;
        this.dialogFormVisible = true;
      },
      showCom(cangkucode){
        this.component.show(cangkucode);
      },
      toFormat() {
        this.component.toFormat();
      },
      toZero(tf){
        this.component.toZero(tf);
      },
      saveData(){
        this.component.saveData();
      },
      showAfter(cangkucode,type) {
        this.initForm();
        this.btnvisible=true;
        switch (type) {
          case 'lens':
            this.showLens = true;
            this.$nextTick(() => {
              this.component=this.$refs.MakeInventoryEdit1;
              this.showCom(cangkucode);
            })
            break;
          case 'frame':
            this.showFrame = true;
            this.$nextTick(() => {
              this.component=this.$refs.MakeInventoryFrameEdit1;
              this.showCom(cangkucode);
            })
            break;
          case 'other':
            this.showOther = true;
            this.$nextTick(() => {
              this.component=this.$refs.MakeInventoryOtherEdit1;
              this.showCom(cangkucode);
            })
            break;
        }
      },
      show(cangkucode,type) {
        if(this.jxcstoreDataf.length==0){
          cusandptbyind().then(response => {
            this.jxcstoreDataf = response.data.obj;
            this.showAfter(cangkucode,type);
          })
        }else{
          this.showAfter(cangkucode,type);
        }
      },
      initDataCom(row){
        this.component.initData(row);
      },
      initData(row,type) {
        this.initForm();
        this.btnvisible=false;
        looklist({
          erpserial: row.erpserial
        }).then(response => {
          var dataRow = response;
          if(!type) {
            if (dataRow.data.obj.filltemplate==80) {
              type='frame';
            }else  if (dataRow.data.obj.filltemplate==40) {
              type='other';
            }else{
              type='lens';
            }
          }

          switch (type) {
            case 'lens':
              this.showLens = true;
              this.$nextTick(() => {
                this.component=this.$refs.MakeInventoryEdit1;
                this.initDataCom(dataRow);
              })
              break;
            case 'frame':
              this.showFrame = true;
              this.$nextTick(() => {
                this.component=this.$refs.MakeInventoryFrameEdit1;
                this.initDataCom(dataRow);
              })
              break;
            case 'other':
              this.showOther = true;
              this.$nextTick(() => {
                this.component=this.$refs.MakeInventoryOtherEdit1;
                this.initDataCom(dataRow);
              })
              break;
          }

        });
      },
    },
    components: {
      MakeInventoryEdit,
      MakeInventoryFrameEdit,
      MakeInventoryOtherEdit,
    },

    mounted() {

    },
  }
</script>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventorySwitch.vue